// utils/alertEngine.js — Alert computation logic (extracted from AlertsTab)
// Used by both AlertsTab (UI) and Analyst Chat (alert scanner skill)

export function computeAlerts(symbol, { rsi, macd, priceChangePercent, volatility, currentPrice, sma50, sma200 }) {
  const alerts = [];

  // RSI alerts
  if (rsi < 30) {
    alerts.push({ type: 'positive', iconKey: 'TrendingUp', title: `RSI Ipervenduto — ${symbol}`, body: `RSI a ${rsi}: zona di forte ipervenduto. Potenziale opportunità di acquisto.`, priority: 1 });
  } else if (rsi < 35) {
    alerts.push({ type: 'warning', iconKey: 'TrendingDown', title: `RSI Basso — ${symbol}`, body: `RSI a ${rsi}: si avvicina alla zona di ipervenduto. Monitorare.`, priority: 2 });
  } else if (rsi > 70) {
    alerts.push({ type: 'negative', iconKey: 'TrendingDown', title: `RSI Ipercomprato — ${symbol}`, body: `RSI a ${rsi}: zona di forte ipercomprato. Possibile correzione in arrivo.`, priority: 1 });
  } else if (rsi > 65) {
    alerts.push({ type: 'warning', iconKey: 'TrendingUp', title: `RSI Alto — ${symbol}`, body: `RSI a ${rsi}: si avvicina alla zona di ipercomprato. Monitorare.`, priority: 2 });
  }

  // Price change alerts
  if (Math.abs(priceChangePercent) > 5) {
    alerts.push({
      type: priceChangePercent > 0 ? 'positive' : 'negative',
      iconKey: priceChangePercent > 0 ? 'TrendingUp' : 'TrendingDown',
      title: `Variazione Forte — ${symbol}`,
      body: `Variazione giornaliera: ${priceChangePercent > 0 ? '+' : ''}${priceChangePercent.toFixed(2)}%. Movimento significativo.`,
      priority: 1
    });
  } else if (Math.abs(priceChangePercent) > 3) {
    alerts.push({
      type: 'warning',
      iconKey: 'AlertCircle',
      title: `Variazione Rilevante — ${symbol}`,
      body: `Variazione giornaliera: ${priceChangePercent > 0 ? '+' : ''}${priceChangePercent.toFixed(2)}%. Sopra la soglia di attenzione.`,
      priority: 2
    });
  }

  // SMA 50 alerts
  if (sma50 != null && currentPrice > 0) {
    const pctFromSma50 = ((currentPrice - sma50) / sma50 * 100).toFixed(1);
    if (currentPrice > sma50) {
      alerts.push({ type: 'positive', iconKey: 'BarChart3', title: `Sopra SMA 50 — ${symbol}`, body: `Prezzo (${currentPrice.toFixed(2)}) sopra la media 50 giorni (${sma50}), +${pctFromSma50}%. Trend rialzista.`, priority: 2 });
    } else {
      alerts.push({ type: 'negative', iconKey: 'BarChart3', title: `Sotto SMA 50 — ${symbol}`, body: `Prezzo (${currentPrice.toFixed(2)}) sotto la media 50 giorni (${sma50}), ${pctFromSma50}%. Pressione ribassista.`, priority: 2 });
    }
  }

  // Golden Cross / Death Cross (SMA 50 vs SMA 200)
  if (sma50 != null && sma200 != null) {
    if (sma50 > sma200) {
      alerts.push({ type: 'positive', iconKey: 'TrendingUp', title: `Golden Cross — ${symbol}`, body: `SMA 50 (${sma50}) sopra SMA 200 (${sma200}). Segnale rialzista di medio-lungo termine.`, priority: 1 });
    } else {
      alerts.push({ type: 'negative', iconKey: 'TrendingDown', title: `Death Cross — ${symbol}`, body: `SMA 50 (${sma50}) sotto SMA 200 (${sma200}). Segnale ribassista di medio-lungo termine.`, priority: 1 });
    }
  }

  // MACD signal
  if (macd !== undefined && macd !== null) {
    if (macd > 0) {
      alerts.push({ type: 'info', iconKey: 'Activity', title: `MACD Positivo — ${symbol}`, body: `MACD a ${macd}: momentum rialzista confermato.`, priority: 3 });
    } else if (macd < 0) {
      alerts.push({ type: 'info', iconKey: 'Activity', title: `MACD Negativo — ${symbol}`, body: `MACD a ${macd}: momentum ribassista.`, priority: 3 });
    }
  }

  // Volatility alert
  if (volatility > 40) {
    alerts.push({ type: 'warning', iconKey: 'AlertCircle', title: `Alta Volatilità — ${symbol}`, body: `Volatilità annualizzata al ${volatility}%. Oscillazioni significative in corso.`, priority: 2 });
  }

  // Sort by priority (1 = highest)
  alerts.sort((a, b) => a.priority - b.priority);
  return alerts;
}
